/**
 * DEV-2502. Черновики поля ввода чата — в sessionStorage: iOS выгружает фоновую
 * вкладку, и набранное пропадало. Живут, пока жива вкладка; выход из учётной записи
 * их стирает (в тексте бывают ПДн клиентов) — как и память фильтров списков.
 */
const PREFIX = 'vp-chat-draft:'

export function readChatDraft(key: string): string {
  try {
    return sessionStorage.getItem(PREFIX + key) ?? ''
  } catch {
    return ''
  }
}

export function writeChatDraft(key: string, text: string): void {
  try {
    if (text) sessionStorage.setItem(PREFIX + key, text)
    else sessionStorage.removeItem(PREFIX + key)
  } catch {
    // Хранилище недоступно (приватный режим Safari) — просто без черновика.
  }
}

export function clearChatDrafts(): void {
  try {
    for (const key of Object.keys(sessionStorage)) {
      if (key.startsWith(PREFIX)) sessionStorage.removeItem(key)
    }
  } catch {
    // Хранилище недоступно — стирать нечего.
  }
}
